export const COMPONENT_NAME = "kyb-documents";
